module.exports = __webpack_public_path__ + "/build/web/images/testimonials-right-2@2x.8fff2814177c2ffa0eaa9fbe7281bd55.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/testimonials-right-2@2x.jpg
// module id = 204
// module chunks = 13